/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import {
  TableRow,
  TableCell,
  IconButton,
  Checkbox,
  Tooltip,
} from '@material-ui/core';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { Error } from '@material-ui/icons';
import {
  getSiteReportsBySiteId,
  changeReportDate,
} from '../../redux/actions/sites';
import ReportsSubTable from './ReportsSubTable';
import { CommonModal } from '../../CommonComponents';
import { showToast } from '../../Utils';

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 25,
    borderRadius: 15,
  },
  colorPrimary: {
    backgroundColor: '#E2BEE8',
  },
  bar: {
    borderRadius: 15,
    backgroundColor: '#9C27B0',
  },
}))(LinearProgress);

const SiteAssignRow = ({
  row,
  labelId,
  frequencyText,
  handleViewDetails,
  handleWatermark,
  vendorUser,
  getSiteReports,
  changeDate,
  addTask,
  selected,
  handleSelect,
}) => {
  const [rowOpen, setRowOpen] = useState(false);
  const [showDatePicker, setDatePicker] = useState(null);
  const [newDate, setNewDate] = React.useState(null);
  const [todayDate] = useState(moment().utcOffset('5:30').format('YYYY-MM-DD'));

  const open = (id) => {
    if (!rowOpen) {
      getSiteReports(id);
      setRowOpen(!rowOpen);
    } else {
      setRowOpen(!rowOpen);
    }
  };

  const handleDayClick = (day) => {
    setNewDate(day);
  };

  const editReportDate = () => {
    if (newDate) {
      changeDate({
        newDate,
        siteReportId: showDatePicker.id,
        siteId: row.id,
      });
      setNewDate(null);
      setDatePicker(null);
    } else {
      showToast('warning', 'Please select date');
    }
  };

  const addNewTask = () => {
    addTask(row.id);
  };

  const stDate = row.newStartDate
    ? todayDate > row.newStartDate
      ? todayDate
      : row.newStartDate
    : todayDate > row.startDate
      ? todayDate
      : row.startDate;
  const isProblem = row?.actionabletasks?.length > 0
    ? row?.actionabletasks.some(
      (item) => item.auditorComments && item.auditorAction === '0',
    )
    : false;
  return (
    <>
      <TableRow
        style={{
          backgroundColor: row.visibleToAuditor ? '#f4e7f6' : 'transparent',
        }}
        hover
        role="checkbox"
        tabIndex={-1}
        key={row.id}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => open(row.id)}
          >
            {rowOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell id={labelId} scope="row" className="pl-0">
          <div className="flex flex-row items-center gap-5">
            <Checkbox
              color="primary"
              checked={selected}
              disabled={!row.onetED && !row.onetSD}
              inputProps={{ 'aria-labelledby': labelId }}
              onChange={(event) => handleSelect(event, row.id)}
              className="p-0"
            />
            <p className="mb-0">{row.siteId}</p>
            {isProblem ? (
              <Tooltip title="Auditor rejected any task" placement="top" arrow>
                <div>
                  <Error htmlColor="#f6c5d3" />
                </div>
              </Tooltip>
            ) : null}
          </div>
        </TableCell>
        <TableCell className="pl-0">
          {moment(row.newStartDate ? row.newStartDate : row.startDate).format(
            'DD MMM YYYY',
          )}
          {' '}
          to
          {' '}
          {moment(row.newEndDate ? row.newEndDate : row.endDate).format(
            'DD MMM YYYY',
          )}
        </TableCell>
        <TableCell>{row.mediaTypeName}</TableCell>
        <TableCell>{row.monitor}</TableCell>
        <TableCell>{row.cityName}</TableCell>
        <TableCell>{row.locationName}</TableCell>
        <TableCell>{row.supplierName}</TableCell>
        <TableCell>{frequencyText}</TableCell>
        <TableCell>{row.campaignNo}</TableCell>
        <TableCell style={{ paddingLeft: 0 }}>
          <Box display="block" alignItems="center">
            {row.onetSD ? (
              <Box display="flex" justifyContent="center">
                {`SD: ${row.onetSD}`}
              </Box>
            ) : null}
            <Box width="100%" className="position-relative">
              <BorderLinearProgress
                variant="determinate"
                value={
                  row.totalReports > 0
                    ? Math.round(
                      (row.submittedReports / row.totalReports) * 100,
                    )
                    : 0
                }
              />
              {row.submittedReports > 0 && (
                <Typography
                  variant="body2"
                  style={{
                    position: 'absolute',
                    right: '1px',
                    top: '4px',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }}
                >
                  {`${Math.round(
                    (row.submittedReports / row.totalReports) * 100,
                  )}%`}
                </Typography>
              )}
            </Box>
            {row.onetED ? (
              <Box display="flex" justifyContent="center">
                {`ED: ${row.onetED}`}
              </Box>
            ) : null}
          </Box>
        </TableCell>
        <TableCell>
          {row.submittedReports}
          /
          {row.totalReports}
        </TableCell>
      </TableRow>
      {showDatePicker && (
        <CommonModal
          title="Change Report Date"
          open
          width="md"
          onYes={editReportDate}
          onClose={() => {
            setDatePicker(null);
            setNewDate(null);
          }}
          successButtonText="Change"
          cancelButtonText="Cancel"
        >
          <DayPicker
            disabledDays={[
              new Date(
                moment(stDate).format('YYYY'),
                moment(stDate).format('MM') - 1,
                moment(stDate).format('DD'),
              ),
              new Date(
                moment(showDatePicker.visitDate).format('YYYY'),
                moment(showDatePicker.visitDate).format('MM') - 1,
                moment(showDatePicker.visitDate).format('DD'),
              ),
              {
                after: new Date(
                  moment(row.newEndDate ? row.newEndDate : row.endDate).format(
                    'YYYY',
                  ),
                  moment(row.newEndDate ? row.newEndDate : row.endDate).format(
                    'MM',
                  ) - 1,
                  moment(row.newEndDate ? row.newEndDate : row.endDate).format(
                    'DD',
                  ),
                ),
                before: new Date(
                  moment(stDate).format('YYYY'),
                  moment(stDate).format('MM') - 1,
                  moment(stDate).format('DD'),
                ),
              },
            ]}
            selectedDays={newDate}
            onDayClick={handleDayClick}
          />
        </CommonModal>
      )}

      <ReportsSubTable
        open={rowOpen}
        site={row}
        vendorUser={vendorUser}
        handleViewDetails={handleViewDetails}
        handleWatermark={handleWatermark}
        setDatePicker={setDatePicker}
        addNewTask={addNewTask}
      />
    </>
  );
};

const mapActions = {
  getSiteReports: getSiteReportsBySiteId,
  changeDate: changeReportDate,
};

export default connect(null, mapActions)(SiteAssignRow);
